export const remediationTypeOptions = [
  { label: 'Type', value: undefined },
  { label: 'Standard', value: 'standard' },
  { label: 'Custom', value: 'custom' },
];
